import { useState } from 'react';
import { useApi, useConsulta } from '@plataforma/web/api';
import { fechaCorta, mxn } from '../formato';
import type { Estimacion } from '../paginas/tipos';

/** Estimaciones de reparación del vehículo (fotos con IA o DTC): una persona aprueba o descarta. */
export function EstimacionesVehiculo({
  vehiculoId,
  alAprobar,
}: {
  vehiculoId: string;
  alAprobar: () => void;
}) {
  const api = useApi();
  const { datos, error, recargar } = useConsulta<Estimacion[]>(
    `/workshop/estimaciones?vehiculoId=${vehiculoId}`,
  );
  const [aviso, setAviso] = useState<string | null>(null);
  const decidir = async (id: string, accion: 'aprobar' | 'descartar') => {
    setAviso(null);
    try {
      await api(
        'POST',
        `/workshop/estimaciones/${id}/${accion}`,
        accion === 'aprobar' ? { vehiculoId } : undefined,
      );
      recargar();
      if (accion === 'aprobar') alAprobar();
    } catch (e) {
      setAviso((e as Error).message);
    }
  };
  if (error && /plan|rol/.test(error)) return null;
  return (
    <section className="seccion">
      <header>
        <h2>Estimaciones de reparación</h2>
      </header>
      {aviso && (
        <p className="error" style={{ margin: 16 }}>
          {aviso}
        </p>
      )}
      {datos && !datos.length ? (
        <p className="vacio">
          Sin estimaciones. Súbelas con fotos o con los códigos DTC del escáner al registrar el
          auto.
        </p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Fuente</th>
              <th className="num">Mínimo</th>
              <th className="num">Esperado</th>
              <th className="num">Máximo</th>
              <th>Estado</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {(datos ?? []).map((e) => (
              <tr key={e.id}>
                <td>{fechaCorta(e.creadaEn)}</td>
                <td>
                  {e.fuente === 'fotos'
                    ? `Fotos (IA${e.modeloIa ? ` · ${e.modeloIa}` : ''})`
                    : 'Códigos DTC'}
                </td>
                <td className="num">{mxn(e.costoMinimoMxn)}</td>
                <td className="num">{mxn(e.costoEsperadoMxn)}</td>
                <td className="num">{mxn(e.costoMaximoMxn)}</td>
                <td>
                  <span
                    className={`etiqueta ${e.estado === 'aprobada' ? 'exito' : e.estado === 'borrador' ? 'aviso' : ''}`}
                  >
                    {e.estado === 'borrador' ? 'por revisar' : e.estado}
                  </span>
                </td>
                <td className="num">
                  {e.estado === 'borrador' && (
                    <>
                      <button className="boton" onClick={() => void decidir(e.id, 'aprobar')}>
                        Aprobar
                      </button>{' '}
                      <button className="boton" onClick={() => void decidir(e.id, 'descartar')}>
                        Descartar
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
